import style from "../style/components/Legal.module.css";
export default () => {
    return (
        <div className={style["container"]}>
            <h1>모두해요 이용약관</h1>
            <p>
                본 이용약관(이하 "이용약관"이라 함)은 주식회사 인네임(이하 "회사")의 애플리케이션(앱) 모두해요,
                소프트웨어, 웹사이트, 제품 등(이하 "서비스")의 이용에 대한 본 이용약관에 의해 규율되며, 모든 정보에 대한
                접근 및 사용에 적용됩니다.{" "}
            </p>
            <h1>제1조(약관 수락)</h1>
            <ul>
                <li>
                    모두해요의 이용자는 회사와 계약을 체결하였으며, 국제사법규를 불문하고 대한민국 법률의 준거절차를
                    따릅니다. 이용자가 회사에 제공하는 모든 정보는 개인정보 수집 및 이용에 관한 회사의
                    개인정보처리방침에 따릅니다. 서비스를 사용함으로써 사용자는 관련 법률에 따른 개인 정보 보호 정책에
                    따라 사용자의 개인 정보를 수집하고 사용하는 데 동의하는 것입니다. 서비스의 일환으로 회사는
                    사용자에게 서비스 알림 및 정보 메시지를 보낼 수 있으며, 이는 서비스의 일부이므로 구독을 취소할 수
                    없습니다.
                </li>
                <li>
                    회사는 이용자 계정의 도용, 허위 정보 제공, 서비스 내 부정 이용 등을 발견한 경우 사후 일정 기간 동안
                    서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.
                </li>
                <li>
                    본 이용약관에 동의하지 않으면 모두해요를 이용할 수 없으므로, 동의하기 전에 잘 확인하신 후 이용하시기
                    바랍니다.
                </li>
            </ul>
            <h1>제2조(약관의 게시 및 개정)</h1>
            <ol>
                <li>
                    회사는 이 약관의 내용을 모두해요 서비스 최초 화면 또는 설정 메뉴 등 별도의 접속 화면 또는 팝업
                    화면을 통해 이용자가 쉽게 이해할 수 있도록 합니다.
                </li>
                <li>
                    회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"이라 한다), 전자상거래
                    등에서의 소비자보호에 관한 법률, 이 약관의 규제에 관한 법률 등 관계법령에 위배되지 않는 범위 내에서
                    이 약관을 개정할 수 있습니다.
                </li>
                <li>
                    회사는 이 약관을 개정하는 경우에는 개정약관의 시행일자 및 개정사유를 명시하고, 현행 약관 제1항에서
                    정한 방법에 따라 개정약관의 시행일 7일 전부터 시행일 전까지를 통지하여야 합니다. 다만, 변경사항이
                    이용자에게 법적으로 불리한 경우에는 시행일 30일 전에 서비스를 통해 동일한 개정사항을 공지하고, 개정
                    내용을 이용자의 이메일 등으로 개별적으로 통지하며, 이용자가 7일 또는 30일 이내에 거부 의사를
                    표시하지 않는 경우에는 이용자는 개정된 약관에 동의한 것으로 간주됩니다.
                </li>
                <li>
                    이용자가 개정약관의 적용에 동의하지 않는 경우, 모두해요의 개정약관의 내용을 적용할 수 없으며, 이
                    경우 이용자는 서비스 이용을 중지하고 이용계약을 해지할 수 있습니다.
                </li>
            </ol>
            <h1>제3조(다른 약관 및 조건)</h1>
            <p>
                이 약관에 명시되지 않은 사항은 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"),
                개인정보보호법, 위치정보의 보호 및 이용에 관한 법률(이하 "위치정보법")에 따릅니다.
                전기통신기본법(Framework on Telecommunications Corporation), 전기통신사업법(Telecommunications
                BusinessAct) 등 관련 법령, 위치기반 서비스 이용약관 및 개인정보처리방침{" "}
            </p>
            <h1>제4조(정의)</h1>
            <p>
                이 약관에서 사용하는 용어의 정의는 제1항에 규정된 경우를 제외하고는 관련 법률 및 서비스별 가이드에
                규정된 경우를 제외하고는 이 약관에 대해서만 유효합니다.
            </p>
            <ol>
                <li>
                    "모두해요"는 서비스 전용 애플리케이션을 휴대폰에서 다운로드, 설치 후 페트병 수거 키오스크의 위치,
                    상태를 확인하고, 페트병 투입 내역과 포인트 적립·사용 내역을 확인하는 등의 기능을 지원하는 서비스를
                    말합니다.
                </li>
                <li>
                    "회원"이라 함은 회원가입을 통하여 본 약관에 동의하고, 서비스 이용을 신청하고, 회사로부터 서비스
                    이용허가를 받은 고객을 말합니다. 다만, 회사는 단계적으로 제공될 서비스 기능(업그레이드 포함)을
                    고려하여 고객의 개인정보(개인위치정보 포함)를 수집하거나 이용하지 않고 서비스의 일부를 이용할 수
                    있는 형태로 서비스를 해제하거나 변경할 수 있습니다.
                </li>
                <li>
                    "서비스"라 함은 모두해요가 제공하는 애플리케이션(App) 및 이와 관련하여 제공되는 프로그램,
                    소프트웨어, 웹사이트, 제품 등을 말합니다
                </li>
                <li>
                    "포인트"라 함은 회원이 모두해요에 투입한 순환자원(페트병)에 대한 보상으로, 회사로부터 발급받은
                    재화를 의미합니다. 포인트 사용 상품은 제휴사별 설정에 따라 제공되며, 활성화된 상품이 없는 경우
                    포인트 사용 신청 기능이 제공되지 않을 수 있습니다.
                </li>
                <li>
                    "서비스"라 함은 모두해요가 제공하는 애플리케이션(App) 및 이와 관련하여 제공되는 프로그램,
                    소프트웨어, 웹사이트, 제품 등을 말합니다.{" "}
                </li>
                <li>
                    “모바일 앱 (Mobile Application)”이란, 회사가 스마트폰 및 모바일 디바이스를 통해 회사의 정보 및 각종
                    서비스를 제공받을 수 있는 스마트폰 전용 애플리케이션을 의미합니다. 본 약관에서 모바일 앱은 ‘모두해요
                    앱’과 동일한 의미로 사용되며, 회사는 AOS(안드로이드용)와 iOS(아이폰용) 앱을 제공합니다.
                </li>
            </ol>
            <h1>제5조(사용 요청)</h1>
            <ol>
                <li>
                    서비스에 가입하여 서비스를 이용하고자 하는 이용자는 본 약관에 동의하고 회원가입 절차를 진행한 후
                    서비스를 이용합니다{" "}
                </li>
                <li>
                    이용자가 서비스에 가입하여 서비스를 이용하고자 하는 경우, 이용자의 모바일 단말기 식별 정보 및 본인
                    확인을 위한 본인 확인 인증 절차를 이용할 수 있습니다. 이 경우, 서비스에 가입하여 서비스를 이용하고자
                    하는 이용자는 해당 인증을 수행하는 등의 등록 절차를 완료해야 합니다.{" "}
                </li>
                <li>
                    이용자의 부주의로 인하여 타인이 이용자 명의로 인증 절차를 밟은 경우, 또는 이용자가 타인의 명의를
                    도용하여 인증을 실시한 경우, 당사는 그로 인해 발생하는 불이익 및 기타 손해에 대해 책임을 지지
                    않습니다.
                </li>
                <li>
                    회사가 서비스 이용을 신청하기 위해 필요한 등록정보를 요청하는 경우, 이용자는 등록정보를 제공해야
                    합니다.
                </li>
                <li>
                    이용자는 자신에 대한 변경 사항을 즉시 업데이트해야 합니다. 이용자가 제공한 등록 정보 및 업데이트된
                    등록 정보가 정확하지 않은 경우, 회사는 서비스 이용을 제한하거나 일시 중지할 수 있습니다.
                </li>
            </ol>
            <h1>제6조(서비스 이용 신청에 대한 동의 유보 및 서비스 이용 제한)</h1>
            <ol>
                <li>
                    제5항에 따른 신청자의 신청에 대해 회사는 원칙적으로 본 서비스의 이용에 동의합니다. 다만, 회사는 그
                    사유가 해소될 때까지 다음 각 호의 어느 하나에 해당하는 신청에 대한 동의를 정지하거나 거절할 수
                    있습니다.{" "}
                </li>
                <ol>
                    <li>이용자 등록 시 타인의 명의를 도용하거나 타인의 정보를 도용하는 등 허위로 신청하는 경우</li>
                    <li>기술적인 이유로 서비스를 제공할 수 없는 경우</li>
                    <li>이용자가 정보를 누락하거나 잘못 등록하여 신청한 경우</li>
                    <li>이메일 인증, SMS 인증 등 회사가 정하는 인증 절차를 완료하지 않은 경우.</li>
                    <li>
                        회사로부터 회원정지 처분을 받은 이용자가 임의로 이용계약을 해지하고 조치기간 내에 재사용을
                        신청하는 경우
                    </li>
                    <li>사회의 안녕, 질서 또는 미풍양속을 어지럽히거나 방해할 목적으로 신청을 하는 경우</li>
                    <li>
                        모두해요 운영 직원 및 관계사 직원에게 폭언, 욕설, 인격침해, 협박, 폭행 등 고의로 업무방해를 한
                        경우 등
                    </li>
                    <li>
                        당사가 정한 이용신청요건이 충족되지 아니하는 경우, 이용신청이 위법 또는 부정하다고 인정되는
                        경우, 이용자의 정당한 사유로 인하여 당사가 승낙할 수 없는 경우
                    </li>
                </ol>
                <li>
                    제1항에 따라 회사가 회원가입 신청을 보류 또는 거부하는 경우, 회사는 가입신청인에게 동의 유보 사유,
                    수락 가능한 시기, 기타 동의 예약 또는 거부에 관한 기타 사항(추가 요청 정보 또는 수락에 필요한 자료
                    등)을 통지할 수 있습니다. SMS 또는 이메일을 통해.
                </li>
                <li>
                    회사는 서비스의 품질 향상 및 기타 필요한 경우의 경우, 이용자를 등급별로 분류할 수 있으며, 필요한
                    사항을 세분화하여 이용을 구분할 수 있습니다.
                </li>
            </ol>
            <h1>제7조(서비스의 보상 정책)</h1>
            <p>순환자원 적립에 대한 포인트의 보상방법은 아래와 같습니다.</p>
            <ol>
                <li>적립 포인트 = 자원 투입 개수 x 회사(혹은 제휴사)가 지정한 적립포인트</li>
                <ul>
                    <li>적립포인트는 자원의 종류, 시기, 지역 및 제휴사 정책에 따라 차등 제공될 수 있습니다.</li>
                    <li>일일 투입 가능한 자원의 개수는 시기, 지역, 제휴사 정책에 따라 차등 제공될 수 있습니다.</li>
                </ul>
                <li>
                    회사는 회원 1명당 일일 투입 가능한 자원의 최대 개수를 수거 키오스크 이용 시 확인가능 하도록
                    부착/홍보하고, 동시에 고객센터 문의 및 민원상담 등의 과정에서 지속적으로 안내하여 이용에 불편함이
                    없도록 노력합니다.{" "}
                </li>
                <li>
                    회원이 수거 키오스크를 이용하여 일일 투입 개수를 초과하였을 경우, 회사는 초과 투입한 자원에
                    대해서는 추가로 보상하지 않습니다
                </li>
                <li>
                    포인트는 회사 및 제휴사의 정책에 따라 적립이 불가할 수 있으며, 정해진 기간에 따라 최고 한도가 정해질
                    수도 있습니다.{" "}
                </li>
                <li>
                    포인트 적립에 오류가 있을 경우 회원은 오류 발생 시점부터 30일 이내에 회사에 정정신청을 하여야 하며,
                    회사는 회원의 정정 요청일부터 30일 이내에 정정할 수 있습니다. 단, 회사가 요청하는 경우 회원은 포인트
                    적립 오류를 증명할 수 있는 자료를 제시하여야 합니다.
                </li>
            </ol>
            <h1>제8조(서비스의 내용 및 규정)</h1>
            <ol>
                <li>회사는 보다 나은 서비스를 제공하기 위해 아래와 같은 서비스를 제공하고 있습니다.</li>
                <ol>
                    <li>수거 키오스크와 운영: 페트병 수거 키오스크를 설치·운영하는 전반의 서비스를 제공합니다. </li>
                    <li>웹사이트: https://moduheyo.web.app/support 를 통한 고객지원 및 정책 안내</li>
                    <li>모바일 앱 : AOS/iOS 앱을 통한 수거 키오스크 위치·상태, 포인트 및 즐겨찾기 정보 제공</li>
                    <li>고객센터 : support@innaim.com을 통해 고객문의를 접수하고 민원을 해결하는 서비스 제공</li>
                    <li>각종 문화활동 : 수거 키오스크 체험 및 교육, 연관 활동을 위한 프로그램들 운영 </li>
                    <li>이벤트 및 프로모션 : 회사 및 제휴사와 함께 다양한 이벤트 및 프로모션을 기획, 운영</li>
                </ol>
            </ol>
            <h1>제9조(서비스 사용 개시)</h1>
            <ol>
                <li>
                    회사는 이용자가 이용요청을 승낙한 때로부터 서비스를 개시합니다. 그러나 일부 서비스는 지정된 날짜부터
                    시작할 수 있습니다.
                </li>
                <li>
                    회사의 업무상 또는 기술적 결함으로 인해 서비스를 시작할 수 없는 경우, 서비스 모바일 애플리케이션
                    또는 서비스 웹사이트에 공고를 통하여 공지합니다.
                </li>
            </ol>
            <h1>제10조(서비스 이용 시간)</h1>
            <ol>
                <li>
                    본 서비스의 이용은 회사의 사업 또는 기술상 특별한 장애가 없는 경우를 제외하고는 원칙적으로 연중무휴
                    24시간 가능합니다. 다만, 정기 점검 등의 필요성에 대해 회사가 정한 요일 또는 시간에는 적용되지
                    않습니다.
                </li>
                <li>
                    회사는 서비스 제공을 위하여 필요한 경우 정기 유지보수를 실시할 수 있으며, 정기 유지보수 시간은
                    서비스 제공 화면에 공지된 바에 따릅니다.
                </li>
                <li>
                    회사는 컴퓨터 등 정보통신설비의 유지보수, 교체, 고장, 통신장애, 운영상의 상당한 사유 또는 상당한
                    운영상의 사유가 있는 경우 서비스 제공을 일시적으로 중단하거나 제한할 수 있습니다. 이 경우 웹사이트
                    공지 또는 사용자 이메일을 통해 귀하에게 통지합니다. 다만, 회사가 통제할 수 없는 사유로 인하여 사전
                    통지가 불가능한 경우에는 그러하지 아니합니다.
                </li>
            </ol>
            <h1>제11조(서비스의 변경 및 중단)</h1>
            <ol>
                <li>
                    회사는 운영적, 기술적 필요에 따라 제공하는 서비스의 전부 또는 일부를 변경할 수 있습니다. 내용,
                    이용방법, 이용시간 등에 변경이 있을 경우, 변경 사유, 변경되는 서비스의 내용, 제공 일시 등을 변경 전
                    해당 서비스 공지사항에 게시합니다.
                </li>
                <li>
                    다음 각 호의 경우 회사는 서비스의 전부 또는 일부의 제공을 일시 중지 또는 종료할 수 있으며, 이 경우
                    웹사이트 공지사항 또는 이용자 이메일 등을 통하여 사전에 귀하에게 통지합니다. 다만, 회사가 통제할 수
                    없는 사유로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니하며, 사유가 해결되는 즉시 통지를
                    실시합니다.
                </li>
                <ol>
                    <li>서비스 설비의 수리 등 공사로 인해 불가피한 상황이 발생한 경우</li>
                    <li>이용자가 이 약관의 규정을 위반한 경우</li>
                    <li>정전, 각종 설비의 고장, 이용의 혼잡 등으로 정상적인 서비스 이용에 지장이 있을 경우</li>
                    <li>
                        서비스 제공자와의 계약 해지, 경영진의 판단 등 회사의 여러 사정으로 인해 서비스를 유지할 수 없는
                        경우
                    </li>
                    <li>천재지변 또는 국가적 비상사태와 같은 기타 불가항력적인 사유가 발생한 경우</li>
                </ol>
                <li>
                    회사가 무료로 제공하는 서비스에 대해 본 조에서 규정한 서비스의 변경, 중지 또는 종료가 발생한 경우,
                    회사는 고의 또는 과실이 없는 한 그로 인해 발생하는 문제에 대해 책임을 지지 않습니다.{" "}
                </li>
            </ol>
            <h1>제12조(정보 제공)</h1>
            <ol>
                <li>회사는 서비스를 운영함에 있어 서비스와 관련된 각종 정보를 서비스 화면에 표시할 수 있습니다.</li>
                <li>
                    회사 또는 관계사는 서비스를 운영함에 있어 이용자의 동의를 얻어 서비스와 관련된 각종 광고를 SMS(MMS),
                    앱푸시, 이메일 등으로 회사에 제공할 수 있습니다.{" "}
                </li>
                <li>
                    서비스에 게재된 광고를 이용하거나 서비스를 통해 광고주의 홍보 활동에 참여함으로써 회사가
                    커뮤니케이션 또는 거래를 하는 것은 이용자의 재량에 따르며, 회사는 이용자와 광고주 사이에 분쟁 또는
                    기타 문제가 발생한 경우 이에 대해 어떠한 책임도 지지 않습니다.
                </li>
            </ol>
            <h1>제13조(위치정보서비스)</h1>
            <ol>
                <li>
                    회사는 위치정보의 보호 및 이용 등에 관한 법률(이하 “위치정보보호법”)에 의거하여 위치정보보호법,
                    정보통신망법, 전기통신기본법, 전기통신사업법 등 관계 법령을 준수하며, 개인위치정보주체와의 권리,
                    의무 및 책임사항을 준수합니다.
                </li>
            </ol>
            <h1>제14조(회사의 의무)</h1>
            <ol>
                <li>
                    회사는 서비스 제공과 관련하여 취득한 이용자의 개인정보를 이용자의 동의 없이 제3자에게 공개하거나
                    배포하지 않습니다. 다만, 관계법령에 의거하여 수사 목적으로 관계기관의 요구가 있거나 법령의 규정에
                    의한 적법한 절차에 의한 경우에는 그러하지 아니합니다.
                </li>
                <li>
                    회사는 서비스와 관련한 이용자의 민원을 신속하게 처리하며, 신속하게 처리하기 곤란한 경우에는 그 사유
                    및 처리일정을 서비스 화면에 게시하거나 전자우편 등으로 이용자에게 고지합니다.
                </li>
                <li>
                    회사는 회원의 수거 키오스크 위치 찾기, 사용가능 상태, 포인트 적립·사용 내역, 즐겨찾기 및
                    개인정보 관리 등의 서비스를 제공합니다.{" "}
                </li>
                <li>
                    회사는 정보통신망법, 위치정보보호법, 통신비밀보호법, 전기통신사업법 등 서비스의 운영 및 유지에 관한
                    법령을 준수합니다.
                </li>
            </ol>
            <h1>제15조(이용자의 의무)</h1>
            <ol>
                <li>이용자는 본 서비스를 이용함에 있어 다음 각 호의 어느 하나에 해당하는 행위를 해서는 안 됩니다.</li>
                <ol>
                    <li>
                        휴대전화 소유자의 허락 없이 활성 이용자가 이용을 신청하거나 용도를 변경하거나, 타인의 계정을
                        도용하거나 부정하게 이용하거나, NICE 휴대전화 본인확인을 부정하게 실시하는 행위
                    </li>
                    <li>
                        회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복사 또는 배포하거나 상업적으로
                        이용하는 행위
                    </li>
                    <li>타인의 명예를 훼손하거나 불이익을 주는 행위</li>
                    <li>당사 또는 제삼자의 저작권 기타 권리를 침해하는 행위</li>
                    <li>
                        본 서비스와 관련된 시설의 고장 또는 정보의 파괴 또는 혼란 등을 일으키는 컴퓨터 바이러스 감염
                        데이터를 등록하거나 배포하는 행위
                    </li>
                    <li>
                        서비스의 운영을 고의로 방해하거나 서비스의 안정적인 운영을 방해할 우려가 있는 정보제공자의
                        명시적인 수신 거부에 반하여 광고성 정보 또는 스팸 메일을 발송하는 행위
                    </li>
                    <li>다른 사용자의 개인 정보를 수집, 저장 또는 공개하는 행위</li>
                    <li>
                        자신 또는 타인에게 재산적 이익을 주거나 타인에게 피해를 줄 목적으로 허위 정보를 유포하는 행위
                    </li>
                    <li>서비스에 게시된 정보의 변경</li>
                    <li>
                        관련 법령에 의해 전송 또는 게시가 금지된 정보(컴퓨터 프로그램 포함)를 전송하거나 게시하는 행위
                    </li>
                    <li>회사의 직원을 사칭하거나 타인의 명의를 사칭하여 전자우편을 게시하거나 발송하는 행위</li>
                    <li>
                        컴퓨터 소프트웨어, 하드웨어 또는 통신 장비의 정상적인 작동을 방해하거나 파괴하도록 설계된
                        소프트웨어 바이러스 또는 기타 컴퓨터 코드, 파일 또는 프로그램이 포함된 자료를 게시하거나
                        이메일로 보내는 행위
                    </li>
                    <li>사업 목적으로 또는 불특정 다수에게 편의를 제공하기 위해 서비스를 이용하는 행위.</li>
                    <li>이용자의 ID를 타인에게 대여하거나 양도하는 행위</li>
                    <li>
                        수신자의 명시적인 사전 동의 없이 댓글이나 1:1 메시지를 이용하여 상업적 목적으로 상업적인 정보를
                        전송하는 행위, 법령에 의해 금지된 재화나 용역에 관한 정보를 광고하는 행위 등
                    </li>
                    <li>기타 불법 또는 부당한 행위</li>
                </ol>
                <li>
                    이용자는 관련 법령, 이 약관의 규정, 이용자 안내 및 서비스에 고지된 주의사항, 회사가 고지하는 사항을
                    준수하고, 기타 회사의 업무에 방해가 되는 행위를 하여서는 아니 됩니다.
                </li>
                <li>
                    이용자가 제1항 내지 제2항에 규정된 행위를 한 경우 회사는 회사가 제공하는 혜택의 일부 또는 전부의
                    회수, 특정 서비스의 이용 제한, 이용 계약의 해지, 손해배상 청구 등의 조치를 취할 수 있습니다.{" "}
                </li>
                <li>
                    회사는 제3항에서 규정한 조치를 취하는 경우 서비스 모바일 앱 또는 서비스 홈페이지에 게시하거나 SMS,
                    앱 푸시, 이메일 등을 통하여 사전에 이용자에게 통지하며, 이용자가 연락이 두절되거나 긴급 상황이
                    발생하는 등 불가피한 경우에는 선제적 조치를 취한 후 통지할 수 있습니다.
                </li>
                <li>이용자는 제3항에 따른 회사의 행위에 대해 항의할 이유가 있는 경우 방어를 할 수 있습니다.</li>
                <li>
                    제3항에서 정하는 바에 따라 이용계약이 종료된 경우, 회사는 이용자의 재이용 청구에 대한 승낙을 거절할
                    수 있습니다.
                </li>
            </ol>
            <h1>제16조(회원에 대한 통지)</h1>
            <ol>
                <li>회사는 이용자에게 통지할 때 SMS, 앱푸시, 이메일 등으로 통지할 수 있습니다.</li>
                <li>
                    불특정 다수의 이용자에게 통지하는 경우, 회사는 서비스 모바일 애플리케이션 또는 서비스 웹사이트
                    공지사항 등에 게시함으로써 개별 통지를 대체할 수 있습니다.{" "}
                </li>
            </ol>
            <h1>제17조(개인 정보의 수정 및 보호)</h1>
            <ol>
                <li>
                    이용자는 이용 신청 시 입력한 정보가 변경된 경우, 즉시 최신 정보로 변경 사항을 수정해야 합니다. 단,
                    본인확인으로 등록된 이름, 전화번호 등 앱에서 직접 변경할 수 없는 항목은 고객지원에 문의해야 합니다.
                </li>
                <li>
                    수정되지 않은 정보로 인해 발생하는 손해는 이용자가 부담해야 하며, 회사는 이에 대한 책임을 지지
                    않습니다.
                </li>
                <li>
                    회사는 이용자의 동의 없이 서비스 제공 목적 이외의 다른 목적으로 이용자의 정보를 이용하거나 제3자에게
                    제공하지 않습니다. 다만, 법령이 이용자의 개인정보 이용 및 제3자에 대한 정보 제공을 허용하는 경우에는
                    예외로 합니다.
                </li>
                <li>
                    회사는 관련 법령이 정하는 바에 따라 이용자 등록 정보를 포함한 이용자의 개인정보를 보호하기 위해
                    노력합니다. 이용자의 개인정보는 관련 법령 및 회사가 정한 개인정보처리방침에 따라 보호됩니다.
                </li>
                <li>
                    회사는 원칙적으로 수집한 개인정보의 취급 및 관리 등의 업무를 자체적으로 수행하되, 필요한 경우 위
                    업무의 일부 또는 전부를 이용자의 동의를 얻거나 이용자에게 통지한 후 회사가 선정한 업체에 위탁할 수
                    있습니다.
                </li>
            </ol>
            <h1>제18조(사용 종료 및 제한)</h1>
            <ol>
                <li>이용자는 다음 각 호의 각 호에서 정하는 바에 따라 이용계약을 해지할 수 있습니다.</li>
                <ol>
                    <li>이용자는 언제든지 회사에 본 약관의 해지 의사를 통지함으로써 이용약관을 해지할 수 있습니다.</li>
                    <li>
                        탈퇴로 인해 발생하는 불이익에 대한 책임은 이용자에게 있으며, 회사는 이용계약이 종료될 때
                        이용자에게 제공된 다양한 혜택을 회수할 수 있습니다.
                    </li>
                </ol>
                <li>
                    회사는 이용자가 이용계약을 체결한 후에도 제15조 제1항 내지 제2항에 규정된 행위를 하여 제재의
                    필요성이 생기면 본 약관 및 회사의 방침에 따라 이용자의 자격을 정지시키거나 이용계약을 해지하거나
                    서비스 이용을 제한할 수 있습니다.
                </li>
                <li>
                    이용자가 탈퇴하면 로그인 계정과 이름, 전화번호, 생년월일, 즐겨찾기 등 회원정보를 삭제하고 미완료
                    포인트 사용 신청을 삭제합니다. 포인트 및 수거 키오스크 이용 기록은 회원 식별자를 제거한 익명
                    기록으로 보관할 수 있습니다.
                </li>
                <li>
                    회사는 이용자가 공공질서 또는 미풍양속을 어지럽히는 행위를 하거나 범죄 행위와 관련하여 이용하는 경우
                    이용자에게 이용정지를 요청할 수 있으며, 이러한 요청에도 불구하고 동일한 행위를 반복하는 경우 회사는
                    이용자에 대한 서비스 이용을 제한할 수 있습니다.
                </li>
            </ol>
            <h1>제19조(환승 불가)</h1>
            <p>
                사용자는 서비스 또는 기타 계약 상태를 사용할 수 있는 권리를 타인에게 양도, 증여 또는 서약할 수 없습니다.
            </p>
            <h1>제20조(면책)</h1>
            <ol>
                <li>
                    이용자가 본 약관의 규정을 위반한 경우, 본 약관을 위반한 이용자는 회사에 발생한 통상적인 손해를
                    배상할 책임이 있으며, 이용자는 그 상황을 알았거나 알 수 있었던 경우에 한하여 특별한 사정으로 인해
                    발생한 손해에 대해 책임을 집니다.
                </li>
                <li>
                    이용자가 이용자를 이용함에 있어 저지른 불법행위 또는 본 약관의 위반행위로 인하여 이용자 이외의
                    제3자로부터 손해배상 청구 또는 소송 등 각종 이의신청을 받은 경우에는 원칙적으로 이용자가 직접 책임을
                    집니다. 다만, 회사는 문제를 제기한 제3자에게 먼저 대응할 수 있으며, 이 과정에서 회사가 비용 또는
                    손해를 입은 경우에는 이용자가 이에 대한 주도권을 행사합니다.
                </li>
                <li>
                    이용자가 회사의 고의 또는 과실로 인하여 손해를 입은 경우, 회사는 그 손해에 대한 책임을 져야 하며, 그
                    책임의 범위는 통상의 손해에 한정됩니다. 그러나 특별한 상황으로 인해 발생한 손해에 대해서는 회사가
                    상황을 알고 있거나 알 수 있었던 경우에만 책임을 집니다.
                </li>
            </ol>
            <h1>제21조(면책 조항)</h1>
            <ol>
                <li>
                    회사가 천재지변 또는 불가항력으로 인하여 서비스를 제공할 수 없는 경우, 회사는 서비스 제공에 대한
                    책임을 면제합니다.
                </li>
                <li>회사는 이용자의 귀책사유로 인한 본 서비스 이용의 불이행에 대해 책임을 지지 않습니다.</li>
                <li>
                    회사는 이용자가 서비스를 통하여 취득한 자료로 인하여 발생한 어떠한 손해에 대하여 고의 또는 과실이
                    없는 한 책임을 지지 않습니다. 당사는 이용자가 본 서비스에 게시한 정보, 자료, 사실 등의 신뢰성과
                    정확성에 대해 책임을 지지 않습니다.
                </li>
                <li>
                    회사는 서비스를 통하여 이용자 상 또는 이용자와 제3자 간에 발생한 분쟁에 개입할 의무가 없으며, 그로
                    인해 발생한 손해에 대해 고의 또는 중대한 과실이 없는 한 배상할 책임을 지지 않습니다.{" "}
                </li>
                <li>
                    회사는 회사의 고의 또는 과실이 없는 한 자신의 개인정보가 유출되거나 타인에게 제공됨으로써 발생하는
                    어떠한 손해에 대해서도 책임을 지지 않습니다.
                </li>
                <li>
                    관련 법률이 허용하는 최대 한도 내에서 서비스의 모든 콘텐츠는 명시적, 묵시적 또는 법적 보증 없이 있는
                    그대로 사용자에게 제공됩니다. 회사는 서비스에서 발견된 모든 오류 및 결함이 신속하게 해결될 수 있음을
                    보증하지 않습니다.
                </li>
                <li>
                    당사는 이용자가 본 서비스와 관련하여 게시한 정보, 자료, 사실 등의 신뢰성 또는 정확성에 대해
                    보증하거나 책임을 지지 않습니다.
                </li>
            </ol>
            <p>귀하가 상황을 알고 있었거나 알 수 있었던 경우, 귀하는 손해에 대한 책임을 져야 합니다.</p>
            <h1>제22조(분쟁 해결 및 관할 법원)</h1>
            <ol>
                <li>
                    서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생한 경우, 회사는 분쟁 해결을 위해 성실하게
                    협의해야 합니다.
                </li>
                <li>
                    본 조 제1항에 따라 분쟁이 해결되지 아니한 경우, 당사자는 민사소송법에 따라 관할법원에 소를 제기할 수
                    있다.{" "}
                </li>
            </ol>
            <p>
                기타 궁금한 사항이 있으시면 <a href="mailto:support@innaim.com">support@innaim.com</a> 로 연락주시면
                성실하게 답변 드리겠습니다.
            </p>
            <h1>부칙</h1>
            <p>본 약관은 2026년 07월 30일부터 시행합니다.</p>
        </div>
    );
};
